export enum TabIndex {
    CapPhepXayDung
}

export type infoSearchHaTangKyThuat = {
    maTenDA?: string,
    chuDT?: string,
    thoigianFrom?: Date,
    thoigianTo?: Date,
    objectId?: number,
    where?: string
}
